<template>
  <div class="content-section h-100">
    <h1 class="content-title text-center">{{ title[fontType] }}</h1>
    <p
      v-for="paragraph in paragraphs"
      :key="paragraph.id"
      class="content-paragraph"
    >
      {{ paragraph.text[fontType] }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ContentSection',
  props: {
    title: {
      type: String,
      required: true
    },
    paragraphs: {
      type: Array,
      required: true,
    },
    fontType: {
      type: String,
      required: true
    },
  }
}
</script>

<style lang="scss" scoped>
.content-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem;
}

.content-title {
  font-size: var(--cus-fs-xx-large);
  font-weight: 900;
  color: goldenrod;
  margin-bottom: 10px;

  @include breakpoint(medium) {
    font-size: var(--cus-fs-xxxxx-large);
    margin-bottom: 20px;
  }
}

.content-paragraph {
  font-family: Poppins;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  padding: 0rem 1rem;
}

@media (max-width: 768px) {
  .content-title {
    font-size: 2rem;
    padding: 0rem;
  }

  .content-paragraph {
    font-size: 1rem;
    padding: 0rem;
  }
  
  .content-section {
    padding: 0rem;
  }
}
</style>
